import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import GitGuardianMappingForm from "./GitGuardianMappingForm";
import GitGuardianCredentialsForm from "./GitGuardianCredentialsForm";


export default function GitGuardianConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={GitGuardianMappingForm}
            CredentialsForm={GitGuardianCredentialsForm}
            componentName="Source Name"
            componentKey="sourceName"
        />
    )
}